<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Добавление руководителя</h1>
      <form @submit.prevent="submitUser">
        <b-field
          label="Имя:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            placeholder="Имя"
            v-model="newLeader.name"
            name="name"
            icon="mdi mdi-account"
            v-validate="{ required: true, min: 2, max: 20 }"
          ></b-input>
        </b-field>
        <b-field
          label="Фамилия:"
          type="is-info"
          class="right_input has_icon"
          :message="errors.first('surname')"
          :class="errors.first('surname') ? 'error' : ''"
        >
          <b-input
            placeholder="Фамилия"
            v-model="newLeader.surname"
            name="surname"
            icon="mdi mdi-account"
            v-validate="{ required: true, min: 2, max: 20 }"
          ></b-input>
        </b-field>
        <b-field
          label="Отчество:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('patronymic')"
          :class="errors.first('patronymic') ? 'error' : ''"
        >
          <b-input
            placeholder="Отчество"
            v-model="newLeader.patronymic"
            name="patronymic"
            icon="mdi mdi-account"
            v-validate="{ required: true, min: 2 }"
          ></b-input>
        </b-field>
        <b-field
          label="Должность:"
          type="is-info"
          class="has_icon right_input"
          :message="errors.first('position')"
          :class="errors.first('position') ? 'error' : ''"
        >
          <b-input
            placeholder="Должность"
            v-model="newLeader.position"
            name="position"
            icon="mdi mdi-account-tie"
            v-validate="{ required: true, min: 2 }"
          ></b-input>
        </b-field>
        <b-field
          label="Email:"
          type="is-info"
          class="login_input has_icon"
          :message="errors.first('email')"
          :class="errors.first('email') ? 'error' : ''"
        >
          <b-input
            placeholder="Email"
            v-model="newLeader.email"
            name="email"
            icon="mdi mdi-email"
            type="text"
            v-validate="{ email: true, regex: /^[^а-яА-Я]+@([^а-яА-Я]+\.)+[^а-яА-Я]{2,}$/ }"
          ></b-input>
        </b-field>
        <button class="add_user_button modal_button left_button" :disabled="errors.items.length > 0">
          Сохранить
        </button>
        <button type="button" @click="$emit('close-modal')" class="close_button modal_button right_button">
          Отмена
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    newLeader: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isOpen: true,
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение',
            max: 'Слишком длинное значение'
          },
          surname: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение',
            max: 'Слишком длинное значение'
          },
          patronymic: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение'
          },
          position: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение'
          },
          email: {
            required: 'Поле не заполнено',
            email: 'Неверный формат',
            regex: 'Email должен состоять из латинских букв'
          }
        }
      }
    }
  },
  methods: {
    submitUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('create-leader')
        }
      })
    },
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    }
  }
}
</script>
